import React from 'react';
import PropTypes from 'prop-types';
import { Table, Button } from 'reactstrap';
import { FormattedMessage } from 'react-intl';
import RoundError from 'react-md-icon/dist/RoundError';
import OutlineDone from 'react-md-icon/dist/OutlineDone';
import { Link } from 'react-router-dom';
import Skeleton from 'react-skeleton-loader';
import { get } from 'lodash';
import { SIMPLE_SIGN_ROUTE, HELLO_SIGN_ROUTE } from '../../constants/globals';

const determineSignatureErrorStatus = (determineSignatureError) => {
  const signedDocs = get(window, 'asure.appSettings.esignature.onboarding.signedDocs', []);
  const docCount = get(window, 'asure.appSettings.esignature.onboarding.docCount', []);
  return docCount !== signedDocs.length && determineSignatureError;
};

const signIcon = (onSign, isSigned, route) => {
  if (isSigned) {
    return (
      <div className="ml-auto d-flex align-items-center">
        <OutlineDone
          style={{
            height: '24px', width: '24px', lineHeight: '24px', color: 'green',
          }}
        />
        <span className="pl-2">Signed</span>
      </div>
    );
  }
  return (
    <Button
      to={route}
      tag={Link}
      onClick={() => onSign()}
      className="ml-auto"
      style={{ backgroundColor: '#009AC7', border: '0' }}
    >
      <FormattedMessage id="REVIEW_AND_SIGN" />
    </Button>
  );
};

const renderDocuments = (isLoading, documents, onSign, isSignatureError) => {
  if (isLoading) {
    let i = 3;
    const skeletonArray = [];
    while (i > 0) {
      i -= 1;
      const element = (
        <tr className="row" key={`skeleton-${i}`}>
          <td className="col col-sm-9 col-xs-6">
            <Skeleton class="ml-auto" width="250px" height="24px" widthRandomness="0.5" borderRadius="0" color="#ededed" />
          </td>
          <td className="col col-sm-3 col-xs-6">
            <div className="ml-auto">
              <Skeleton class="ml-auto" width="140px" height="24px" widthRandomness="0" borderRadius="0" color="#ededed" />
            </div>
          </td>
        </tr>
      );
      skeletonArray.push(element);
    }
    return skeletonArray;
  }
  return documents.map((docs) => {
    if (docs.type === 'SignatureRequest') {
      const signedDocs = get(window, 'asure.appSettings.esignature.onboarding.signedDocs', []);
      if (docs.isHelloSignDocument) {
        const onboardingSignature = docs.signatures.filter(signature => signature.signer.role === 'OnboardingSignatory')[0];
        const isSigned = docs.status === 'Complete' || signedDocs.indexOf(onboardingSignature.id) > -1;
        const onSignThisDoc = () => onSign(docs);
        return (
          <tr className="row" key={docs.id}>
            <td className={`col col-sm-9 col-xs-6 ${isSignatureError && !isSigned ? 'unsigned-row' : ''}`}>{docs.title}</td>
            <td className="col col-sm-3 col-xs-6">{signIcon(onSignThisDoc, isSigned, HELLO_SIGN_ROUTE)}</td>
          </tr>
        );
      // simple sign docs
      } else {
        const isSigned = docs.status === 'Signed' || signedDocs.indexOf(docs.id) > -1;
        const onSignThisDoc = () => onSign(docs);
        return (
          <tr className="row" key={docs.id}>
            <td className={`col col-sm-9 col-xs-6 ${isSignatureError && !isSigned ? 'unsigned-row' : ''}`}>{docs.title}</td>
            <td className="col col-sm-3 col-xs-6">{signIcon(onSignThisDoc, isSigned, SIMPLE_SIGN_ROUTE)}</td>
          </tr>
        );
      }
    }
    return null;
  });
};

const DocumentList = ({
  documents,
  title,
  onSign,
  isLoading,
  determineSignatureError,
}) => (
  <Table className="table-hover mt-4">
    <thead>
      <tr className="small bg-gray-50 d-flex font-weight-bold">
        <th colSpan={2} className="border-0 docs-heading"><FormattedMessage id={title} /></th>
      </tr>
      {determineSignatureErrorStatus(determineSignatureError) ?
        <tr className="row">
          <td className="col signature-warning"><RoundError style={{ fontSize: '1.5rem', lineHeight: 1 }} /></td>
          <td className="col my-auto pl-2 signature-warning"><FormattedMessage id="REVIEW_AND_SIGN_WARNING" /></td>
        </tr>
      :
        undefined
      }
    </thead>
    <tbody className="border-bottom">
      {renderDocuments(isLoading, documents, onSign, determineSignatureErrorStatus(determineSignatureError))}
    </tbody>
  </Table>
);

DocumentList.defaultProps = {
  documents: [],
  determineSignatureError: false,
};

DocumentList.propTypes = {
  documents: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    isHelloSignDocument: PropTypes.string.isRequires,
    status: PropTypes.oneOf(['Pending', 'Complete', 'Declined', 'Unknown']).isRequired,
    signatures: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.string.isRequired,
      status: PropTypes.oneOf(['Pending', 'Complete', 'Declined', 'Unknown']),
      signer: PropTypes.shape({
        emailAddress: PropTypes.string,
        name: PropTypes.string,
        role: PropTypes.string,
      }).isRequired,
    })),
  })),
  onSign: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  isLoading: PropTypes.bool.isRequired,
  determineSignatureError: PropTypes.bool.isRequired,
};

export default DocumentList;



// WEBPACK FOOTER //
// ./src/components/DocumentList/DocumentList.jsx